import { initTabSteps } from '../../components/tab_steps'
import { configureImageUploadComponents } from '../../components/image_upload_input'
import { initTACValidation } from '../../utils/common'
import { toggleStateField } from '../../components/state'

const ACCREDITATION_TYPE_OTHER = '5'

function toggleAccreditationTypeOther(
  selectedAccreditationType: string | null,
) {
  const element = document.getElementById(
    'id_accreditation-accreditation_type_other',
  )
  if (element?.parentElement) {
    element.parentElement.hidden =
      selectedAccreditationType !== ACCREDITATION_TYPE_OTHER
    if (selectedAccreditationType === ACCREDITATION_TYPE_OTHER) {
      element.setAttribute('required', '')
    } else {
      element.removeAttribute('required')
    }
  }
}

function showOrHideAccreditation(
  elements: HTMLElement[],
  addAccreditation: boolean,
  accreditationType: HTMLSelectElement,
) {
  for (const element of elements) {
    if (addAccreditation) {
      if (element?.id === 'id_file-file') {
        const fileParent = document.getElementById(
          'accreditation_file',
        ) as HTMLElement
        fileParent.hidden = false
        element.setAttribute('required', '')
      } else {
        if (element?.parentElement) {
          if (
            element.id === 'id_accreditation-accreditation_type_other' &&
            accreditationType.value !== ACCREDITATION_TYPE_OTHER
          ) {
            element.parentElement.hidden = true
          } else {
            element.parentElement.hidden = false
            if (
              element.id === 'id_accreditation-accreditation_type' ||
              element.id === 'id_accreditation-date_of_expiry' ||
              element.id === 'id_accreditation-accreditation_type_other'
            ) {
              element.setAttribute('required', '')
            }
          }
        }
      }
    } else {
      if (element?.id === 'id_file-file') {
        element.removeAttribute('required')
        const fileParent = document.getElementById(
          'accreditation_file',
        ) as HTMLElement
        fileParent.hidden = true
      } else {
        if (element?.parentElement) {
          element.parentElement.hidden = true
          element.removeAttribute('required')
        }
      }
    }
  }
}

function initRegistrationFormTabs() {
  initTabSteps({ defaultHash: '#account' })
}

function initAgencyRegistrationForm() {
  const accreditationType = document.getElementById(
    'id_accreditation-accreditation_type',
  ) as HTMLSelectElement
  toggleAccreditationTypeOther(accreditationType?.value)

  accreditationType.addEventListener('change', function () {
    toggleAccreditationTypeOther(this.value)
  })

  const accreditationFile = document.getElementById(
    'id_file-file',
  ) as HTMLElement
  const accreditationId = document.getElementById(
    'id_accreditation-id_or_number',
  ) as HTMLElement
  const accreditationIssueDate = document.getElementById(
    'id_accreditation-date_of_issue',
  ) as HTMLElement
  const accreditationExpireDate = document.getElementById(
    'id_accreditation-date_of_expiry',
  ) as HTMLElement
  const accreditationTypeOther = document.getElementById(
    'id_accreditation-accreditation_type_other',
  ) as HTMLElement

  const accreditationElements: HTMLElement[] = []
  accreditationElements.push(accreditationFile)
  accreditationElements.push(accreditationType)
  accreditationElements.push(accreditationTypeOther)
  accreditationElements.push(accreditationId)
  accreditationElements.push(accreditationIssueDate)
  accreditationElements.push(accreditationExpireDate)

  const addAccreditation = document.getElementById(
    'id_accreditation-add_accreditation',
  ) as HTMLInputElement

  showOrHideAccreditation(
    accreditationElements,
    addAccreditation.checked,
    accreditationType,
  )

  addAccreditation?.addEventListener('change', function () {
    showOrHideAccreditation(
      accreditationElements,
      addAccreditation.checked,
      accreditationType,
    )
  })

  initRegistrationFormTabs()
  configureImageUploadComponents()
  initTACValidation('detail-has_accepted_flywire_tac')

  const stateField = document.getElementById(
    'id_detail-state',
  ) as HTMLSelectElement
  stateField.addEventListener('change', function () {
    toggleStateField(stateField, 'id_detail-state')
  })
}

export { initAgencyRegistrationForm }
